export const fmtMoney = (n) => {
  if (n === null || n === undefined) return "PKR 0.00";
  return new Intl.NumberFormat('en-PK', { style: 'currency', currency: 'PKR' }).format(n);
};

export const pillCls = (status) => {
  status = (status || "").toLowerCase();
  if (status.includes("draft")) return "pill-draft";
  if (status.includes("open")) return "pill-open";
  if (status.includes("paid")) return "pill-paid";
  if (status.includes("posted")) return "pill-posted";
  if (status.includes("active")) return "pill-asset";
  return "pill-draft";
};